import { render, staticRenderFns } from "./UserMenuItem.vue?vue&type=template&id=bf489c98&scoped=true"
import script from "./UserMenuItem.vue?vue&type=script&lang=ts"
export * from "./UserMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./UserMenuItem.vue?vue&type=style&index=0&id=bf489c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf489c98",
  null
  
)

export default component.exports